<template>
  <bootstrap-modal
    :modal-title="modalTitle"
    :is-open="isModalOpen"
    size="sm"
    @modal:close="closeStudentEnrollmentModal"
    @modal:okay="submitStudentEnrollment"
  >
    <form>
      <form-row>
        <p class="text-center col-12">
          如果於報名後想做更改，<br>
          請在報名時間內做修改動作
        </p>
      </form-row>
      <form-row>
        <form-group cols="12">
          <input-group>
            <template slot="prepend">
              <span
                aria-hidden="true"
                class="input-group-text text-muted"
              >
                <font-awesome-icon icon="calendar-alt" />
              </span>
            </template>
            <form-input
              v-model="orientationTimeSlot.orientation_date"
              name="orientation-date"
              readonly
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group cols="12">
          <input-group>
            <template slot="prepend">
              <span
                aria-hidden="true"
                class="input-group-text text-muted"
              >
                <font-awesome-icon :icon="['far', 'clock']" />
              </span>
            </template>
            <form-input
              v-model="orientationTimeSlot.duration"
              name="orientation-time"
              readonly
            />
          </input-group>
        </form-group>
      </form-row>
    </form>
  </bootstrap-modal>
</template>
<script>
import BootstrapModal from '~bootstrap/Modal'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'
export default {
  name: 'EnterpriseEnrollRecruitmentOrientationModal',
  components: {
    BootstrapModal,
    FormRow,
    FormGroup,
    FormInput,
    InputGroup
  },
  props: {
    isModalOpen: Boolean,
    modalTitle: {
      type: String,
      required: true
    },
    orientationTimeSlot: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    closeStudentEnrollmentModal () {
      this.$emit('modal:close')
    },
    submitStudentEnrollment () {
      this.$emit('submit')
    }
  }
}
</script>
